import React from "react";
import { I18n } from "@aws-amplify/core";
import { withStyles } from "@material-ui/styles";
import { get, map, sortBy, filter, size } from "lodash";

import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";

import InfoSection from "../Common/InfoSection";
import DetailsContainer from "../Common/DetailsContainer";
import Attribute from "../Common/Attribute";
import Picture from "../Common/Picture";

import { formatDate } from "../../utils/date";
import { getLovValue } from "../../utils/profile";
import { getSiteZone } from "../../utils/eventGroups";

import { eventGroups } from "../../constants/common";

import colors from "../../assets/style/colors";
import images from "../../assets/img/images";

const styles = {
  foldableAttrSection: {
    color: colors.black87,
    textTransform: "uppercase",
    fontWeight: 500,
    paddingLeft: "8px",
    marginBottom: "8px",
    cursor: "pointer",
    "&:hover": {
      textDecoration: "underline",
    },
    "& img": {
      marginRight: "5px",
    },
  },
  borderedPicture: {
    border: "1px solid " + colors.veryLighPink,
    width: "72px",
    height: "72px",
    borderRadius: "2px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginRight: "12px",
  },
};

const EventDetailsDetails = (props) => {
  const { classes, data, language, lov, type, goToEventGroup,parentEventData } = props;
  const [expandPrimary, setExpandPrimary] = React.useState(true);
  const [expandSecondary, setExpandSecondary] = React.useState(false);

  const renderEventGroupDetails = () => {
    return (
      <>
        <Grid item xs={6}>
          <InfoSection
            title="start"
            values={[
              get(parentEventData, ["created_on"]) ? formatDate(get(parentEventData, ["created_on"])) : "-",
            ]}
          />
          <InfoSection
            title="end"
            values={[get(parentEventData, ["end"]) ? formatDate(get(parentEventData, ["end"])) : "-"]}
          />
          <InfoSection title="name" values={[get(data, ["profile", "name"])]} />
          <InfoSection title="eventGroupId" values={[get(data, ["id"])]} />
          <InfoSection
            title="description"
            values={[get(data, ["description"])]}
          />
          <InfoSection
            title="siteZone"
            values={[
              get(getSiteZone(data), [0])
                ? `${get(getSiteZone(data), [0])} / ${get(getSiteZone(data), [
                    1,
                  ])}`
                : "",
            ]}
          />
        </Grid>
        <Grid item xs={6}>
          <InfoSection
            title="deviceName"
            values={[get(data, ["events", 0, "device", "name"]) || "-"]}
          />
          <InfoSection
            title="riskLevel"
            values={[
              get(data, ["risk_level"]) !== undefined &&
                get(lov, ["riskLevel"]) &&
                getLovValue(
                  "riskLevel",
                  get(data, ["risk_level"]),
                  lov,
                  language
                ),
            ]}
          />
          <InfoSection title="status" values={[""]} />
          <InfoSection
            title="createdOn"
            values={[formatDate(get(data, ["created_on"]))]}
          />
          <InfoSection title="createdBy" values={[get(data, ["created_by"])]} />
          <InfoSection title="active" values={[get(data, ["active"])]} />
        </Grid>
      </>
    );
  };

  const renderEventDetails = () => {
    const mainAttr = sortBy(
      filter(get(data, ["attributes"]), (attr, index) =>
        get(attr, ["app_display_main_page"])
      ),
      (attr) => get(attr, ["app_display_seq_numb"])
    );
    const secondaryAttr = sortBy(
      filter(
        get(data, ["attributes"]),
        (attr, index) => !get(attr, ["app_display_main_page"])
      ),
      (attr) => get(attr, ["app_display_seq_numb"])
    );
    return (
      <>
        <DetailsContainer title={I18n.get("site_photos")}>
          <Grid container>
            {map(get(data, ["images"]), (img) => (
              <Box className={classes.borderedPicture} key={get(img, ["id"])}>
                <Picture
                  url={get(img, ["url"])}
                  maxHeight={70}
                  alt="event_picture"
                  style={{ maxHeight: "70px", maxWidth: "70px" }}
                />
              </Box>
            ))}
          </Grid>
        </DetailsContainer>
        <DetailsContainer title={I18n.get("site_mainDetails")}>
          <Grid container direction="column">
            <Grid item>
              <Grid container>
                <Grid item xs={6}>
                  <Grid container direction="column">
                    <InfoSection
                      title="eventType"
                      values={[get(data, ["type", `name_${language}`])]}
                    />
                    <InfoSection
                      title="eventVersion"
                      values={[get(data, ["event_version"])]}
                    />
                    <InfoSection
                      title="createdOn"
                      values={[formatDate(get(data, ["created_on"]))]}
                    />
                    <InfoSection
                      title="createdBy"
                      values={[get(data, ["created_by"])]}
                    />
                    <InfoSection
                      title="active"
                      values={[get(data, ["active"])]}
                    />
                  </Grid>
                </Grid>
                <Grid item xs={6}>
                  <Grid container direction="column">
                    <InfoSection
                      title="eventGroupId"
                      values={[]}
                      link={{
                        value: get(data, ["group", "id"]),
                        onClick: () =>
                          goToEventGroup(get(data, ["group", "id"])),
                      }}
                    />
                    <InfoSection
                      title="parentEventId"
                      values={[get(data, ["parent_event_id"])]}
                    />
                    <InfoSection title="eventId" values={[get(data, ["id"])]} />
                    <InfoSection
                      title="referenceEventId"
                      values={[get(data, ["reference_event_id"])]}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <Grid item style={{ marginTop: "20px" }}>
              <Box
                className={classes.foldableAttrSection}
                onClick={() => setExpandPrimary(!expandPrimary)}
              >
                <img
                  src={expandPrimary ? images.bottomArrow : images.rightArrow}
                  alt="arrow"
                />
                {I18n.get("events_primaryAttributes")}
              </Box>
              {expandPrimary && (
                <Grid container>
                  <Grid item xs={6}>
                    <Grid container direction="column">
                      {map(
                        filter(
                          mainAttr,
                          (attr, index) => index < size(mainAttr) / 2
                        ),
                        (attr) => (
                          <Attribute
                            key={get(attr, ["id"])}
                            data={data}
                            id={get(attr, ["id"])}
                            parentEventData={parentEventData}
                          />
                        )
                      )}
                    </Grid>
                  </Grid>
                  <Grid item xs={6}>
                    <Grid container direction="column">
                      {map(
                        filter(
                          mainAttr,
                          (attr, index) => index >= size(mainAttr) / 2
                        ),
                        (attr) => (
                          <Attribute
                            key={get(attr, ["id"])}
                            data={data}
                            id={get(attr, ["id"])}
                            parentEventData={parentEventData}
                          />
                        )
                      )}
                    </Grid>
                  </Grid>
                </Grid>
              )}
            </Grid>
            <Grid item style={{ marginTop: "20px" }}>
              <Box
                className={classes.foldableAttrSection}
                onClick={() => setExpandSecondary(!expandSecondary)}
              >
                <img
                  src={expandSecondary ? images.bottomArrow : images.rightArrow}
                  alt="arrow"
                />
                {I18n.get("events_secondaryAttributes")}
              </Box>
              {expandSecondary && (
                <Grid container>
                  <Grid item xs={6}>
                    <Grid container direction="column">
                      {map(
                        filter(
                          secondaryAttr,
                          (attr, index) => index < size(secondaryAttr) / 2
                        ),
                        (attr) => (
                          <Attribute
                            key={get(attr, ["id"])}
                            data={data}
                            id={get(attr, ["id"])}
                          />
                        )
                      )}
                    </Grid>
                  </Grid>
                  <Grid item xs={6}>
                    <Grid container direction="column">
                      {map(
                        filter(
                          secondaryAttr,
                          (attr, index) => index >= size(secondaryAttr) / 2
                        ),
                        (attr) => (
                          <Attribute
                            key={get(attr, ["id"])}
                            data={data}
                            id={get(attr, ["id"])}
                          />
                        )
                      )}
                    </Grid>
                  </Grid>
                </Grid>
              )}
            </Grid>
          </Grid>
        </DetailsContainer>
      </>
    );
  };

  return (
    <Grid
      container
      direction={type === eventGroups ? "row" : "column"}
      style={{ padding: "12px" }}
    >
      {type === eventGroups ? renderEventGroupDetails() : renderEventDetails()}
    </Grid>
  );
};

export default withStyles(styles)(EventDetailsDetails);
